module.exports = __webpack_public_path__ + "static/media/orion.027198cc.jpg";